<template>
    <div style="background-color: white; min-height: 100vh; padding-bottom: 20px;" class="d-md-none d-lg-none">
        <div class="top-container">
            <header class="header">
                <button class="back-button" @click="goBack">←</button>
                <h2 class="custom-16px-500 font-color-101828">Checkout</h2>
                <button class="delete-button"><img src="../assets/img/new/3dot.png" width="20px"/></button>
            </header>
        </div>
        <div class="onboarding-container" style="background-size: cover;background-color: #fff;">
            <div class="slider-wrapper">
                <div class="slider" :style="sliderStyle">
                    <div v-for="(screen, index) in screens" :key="index" class="slide" :class="{ 'active-slide': index === step - 1 }">
                        <div class="image-container relative">
                            <img src="../assets/img/new/bg-purple.png" class="onboarding-image" />
                            <div class="overlay relative flex flex-col items-center text-center">
    
                                <!-- Diamond Icon with Price Inside (Top Right) -->
                                <div class="absolute top-2 right-2 flex items-center space-x-1 bg-purple-600 px-2 py-1 rounded-lg">
                                    <img src="../assets/img/new/diamond.png" width="20px" class="relative" />
                                    <span class="text-white text-xs font-bold position-right mr-3">$9.90/Month</span>
                                </div>
    
                                <!-- Title -->
                                <span class="text-white mt-2 custom-18px-600">{{ screen.title }}</span>
    
                                <!-- Features List -->
                                <ul class="text-white text-sm mt-2">
                                    <li>Video less than 60 sec</li>
                                    <li>20 video per mth</li>
                                </ul>
    
                                <!-- Choose Package Button -->
                                <CButton type="button" class="bg-white border-half font-color-928AFD" block>
                                    Choose Package
                                </CButton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <!-- Pagination Dots -->
            <div class="pagination mb-2">
                <span v-for="(screen, index) in screens" :key="index" :class="{ active: index + 1 === step }" @click="goToStep(index + 1)"></span>
            </div>
        </div>
        <CCol sm="12" class="bg-white">
            <h3 class="custom-14px-400 font-color-171717">
                Payment Method
            </h3>
            <v-select v-model="selectedPaymentMethod" :options="paymentMethods" label="label">
                <!-- Customizing dropdown options -->
                <template #option="{ label, icon }">
                        <div style="display: flex; align-items: center;">
                            <img v-if="icon" :src="icon" alt="" style="width: 24px; height: 16px; margin-right: 8px;">
                            <span>{{ label }}</span>
                        </div>
</template>

                <!-- Customizing selected option -->
<template #selected-option="{ label, icon }">
    <div style="display: flex; align-items: center;">
        <img v-if="icon" :src="icon" alt="" style="width: 24px; height: 16px; margin-right: 8px;">
        <span>{{ label }}</span>
    </div>
</template>

            </v-select>
            
                <h3 class="custom-14px-400 font-color-171717 mt-3">
                    Promo
                </h3>
                <div class="input-with-icon">
                    <img src="../assets/img/new/promo.png" class="input-icon" />
                    <CInput type="text" placeholder="Search..." />
                </div>
                <br />
            </CCol>
            <CCol sm="12" class="position-bottom bg-white">
                <h3 class="custom-12px-400 font-color-98A2B3">Total</h3>
                <h3 class="custom-18px-600 font-color-101828">$9.99</h3>
                <CButton type="button" class="custom-border-purple text-white" block @click="OpenPayment()">Checkout now</CButton>
            </CCol>

            <div v-if="showPopup" class="popup-all backdrop-all">
                <div class="popup-all1">
          <!-- Success Icon -->
          <div class="success-icon">
            <img src="@/assets/img/new/success-icon.png" alt="Success" style="max-width:100%"/>
          </div>

          <!-- Payment Success Text -->
          <div class="text-center">
          <h3 class="popup-title custom-24px-500 text-center">Payment Success</h3>
          <p class="popup-message custom-14px-400 text-center">
            Your payment has been successfully processed. Thank you for subscribing! 
            You can now enjoy all the features of your chosen package.
          </p>
        </div>

          <!-- Go Home Button -->
          <CButton class="custom-border-purple" color="primary" block @click="ViewReceipt">
            View Receipt
          </CButton>
                </div></div>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

import _ from "lodash";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurplerectangle.png";
import bgdiamond from "../assets/img/new/bgdiamond.jpeg";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";
import Footerweb from "../containers/FooterWeb.vue";
import ToggleCard from '../components/Toggle.vue';
import backgroundUrNoArrow from "../assets/img/bgline.png";
import avatar from "@/assets/img/new/userprofile.png";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
        Footerweb
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,
            bgdiamond,
            step: 1,

            screens: [{
                    image: require("@/assets/img/new/banner1.png"),
                    title: "Standard",
                    description: "60% off"
                },
                {
                    image: require("@/assets/img/new/banner1.png"),
                    title: "Premium",
                    description: "Complete surveys and earn exclusive discounts."
                },
                {
                    image: require("@/assets/img/new/banner1.png"),
                    title: "Pro",
                    description: "Join now and explore amazing deals."
                }
            ],
            user: {
                avatar: avatar,
                name: "Gustavo Levin",
                username: "gustavo.levin",
                bio: "Dream big, work hard, stay focused, and surround yourself with good energy. 💪",
                posts: 24,
                following: 490,
                followers: "12.8k",
            },
            categories: [
                { imgSrc: require('@/assets/img/new/fb.png'), label: 'F&B' },
                { imgSrc: require('@/assets/img/new/hospitality.png'), label: 'Hospitality' },
                { imgSrc: require('@/assets/img/new/edu.png'), label: 'Education' },
                { imgSrc: require('@/assets/img/new/services.png'), label: 'Services' }
            ],
            reviews: [{
                    title: "Service Review of every Honda showroom and repair...",
                    organizer: "Honda",
                    duration: 5,
                    image: require('@/assets/img/new/re1.png') // Replace with real image
                },
                {
                    title: "Customer feedback on Toyota dealership",
                    organizer: "Toyota",
                    duration: 7,
                    image: require('@/assets/img/new/re1.png')
                }
            ],
            selectedPaymentMethod: null,
            paymentMethods: [{
                    label: "Visa Card",
                    value: "visa",
                    expiry: "05/2025",
                    icon: require("@/assets/img/new/visa.png"),
                },
                {
                    label: "Mastercard",
                    value: "mastercard",
                    expiry: "01/2027",
                    icon: require("@/assets/img/new/mastercard.png"),
                },
            ],
            showPopup: false

        };
    },
    computed: {
        sliderStyle() {
            return {
                transform: `translateX(-${(this.step - 1) * 100}%)`, // Shift left for sliding effect
                transition: 'transform 0.5s ease-in-out' // Smooth transition
            };
        }
    },
    created() {
        AOS.init();

    },
    watch: {
        selectedPaymentMethod(newVal) {
            console.log("Selected Payment Method:", newVal);
        }
    },
    methods: {
        GoToEvoucher() {
            this.$router.push("SelectionEvoucher");
        },
        nextStep() {
            if (this.step < this.screens.length) {
                this.step++;
            }
        },
        goToStep(index) {
            this.step = index;
        },
        GoToIndustries() {
            this.$router.push("DetailIndustries");
        },
        goBack() {
            this.$router.go(-1); // Navigate to the previous page
        },
        openPaymentOptions() {
            this.showPaymentOptions = true;
        },
        selectPayment(value) {
            this.selectedPayment = value; // Update selected payment
        },
        ViewReceipt()
        {
            this.$router.push("SlipPayment");

        },
        OpenPayment()
        {
            this.showPopup = true;
        }
    }


};
</script>


<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.image-container {
    position: relative;
    max-width: 100%;
}

.background-image {
    width: 100%;
    height: auto;
}

pre {
    white-space: pre-wrap;
    /* Ensures that newlines and spaces are rendered as expected */
    color: #171717;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 27px */
}

.bottom-right-button {
    position: absolute;
    bottom: 20px;
    /* Adjust as needed */
    right: 80px;
    /* Adjust as needed */
    padding: 10px 20px;
    background-color: #007bff;
    /* Button color */
    color: white;
    border: none;
    border-radius: 20px;
    cursor: pointer;
}

.bottom-right-button-text {
    position: absolute;
    bottom: 90px;
    /* Adjust as needed */
    right: 20px;
    /* Adjust as needed */
    padding: 10px 20px;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    color: #000;
    font-weight: 600;
}

.bottom-right-button:hover {
    background-color: #0056b3;
    /* Hover color */
}

/* .popup-all1 {
    width: 500px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 2%;
    height:70vh;
} */

.popup-all2 {
    width: 900px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 20px;
    z-index: 1000;
    margin: 0 auto;
    margin-top: 4%;
    z-index: 1;
    height: 90vh;
}

.salary-range {
    padding: 20px;
}

.progress {
    height: 20px;
    background-color: #e9ecef;
    border-radius: 4px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    background-color: #007bff;
}

.custom-range {
    width: 100%;
}

.input-container {
    position: relative;
    display: inline-block;
    width: 100%;
}

input[type="text"].custom {
    padding-right: 60px;
    /* Adjust according to button width */
    height: 80px;
}

.verify-button {
    position: absolute;
    right: 2px;
    top: 3px;
    bottom: 3px;
    height: 28px;
    border-radius: 50px;
    background: #928AFD;
    color: #fff;
    /* Optional: Adjust the button height to match the input field */
}

.disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.onboarding-container {
    margin: auto;
    padding: 10px;
}

.slider-wrapper {
    overflow: hidden;
    width: 100%;
}

.slider {
    display: flex;
    transition: transform 0.5s ease-in-out;
    white-space: nowrap;
    align-items: stretch;
    /* Ensures all slides have the same height */
}

.slide {
    min-width: 100%;
    padding: 10px;
    transition: opacity 0.5s, transform 0.5s;
    height: 100%;
    /* Ensure all slides remain the same height */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.active-slide {
    opacity: 1;
    transform: scale(1);
    /* Ensure the active slide does not change in size */
}

.slide:not(.active-slide) {
    opacity: 0.6;
    /* Dim non-active slides */
    transform: scale(1);
    /* Keep all slides the same size */
}

.image-container {
    position: relative;
    width: 100%;
    height: 100%;
    /* Ensure the image container takes full height */
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.onboarding-image {
    width: 100%;
    height: 100%;
    /* Make all images the same height */
    border-radius: 10px;
    object-fit: cover;
    /* Ensures the image maintains proportion */
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* Dark overlay */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 20px;
    border-radius: 10px;
    color: white;
}

.badge {
    background: #fff;
    color: #928AFD;
    padding: 5px 10px;
    border-radius: 15px;
    font-size: 8px;
    font-weight: 600;
}

.overlay-title {
    font-size: 20px;
    font-weight: bold;
    margin-top: 10px;
}

.overlay-text {
    font-size: 14px;
    margin-top: 5px;
    color: var(--Neutral-10, var(--Color-Neutral-10, #FFF));
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: capitalize;
    white-space: normal;
}

.overlay-btn {
    background: white;
    color: #928AFD;
    padding: 5px 10px;
    border-radius: 15px;
    font-size: 8px;
    font-weight: 600;
    bottom: 10px;
    right: 5px;
    position: absolute;
}

.pagination {
    display: flex;
    justify-content: center;
    gap: 5px;
}

.pagination span {
    width: 10px;
    height: 10px;
    background: #ccc;
    border-radius: 50%;
    cursor: pointer;
    transition: background 0.3s;
}

.pagination span.active {
    background: #fff;
}

.profile-container {
    background: white;
    padding: 20px;
}

.profile-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
}

.profile-name,
.profile-username,
.profile-bio {
    text-align: left;
    margin-left: 20px;
    width: max-content;
}

.stats-row p {
    font-size: 12px;
    /* Adjust to a smaller size */
    white-space: nowrap;
    /* Prevent text from breaking into a new line */
}

.profile-tabs {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    background: #f5f5f5;
    border-radius: 20px;
    padding: 5px;
}

.tab-row {
    width: 100%;
}

.tab-col {
    display: flex;
    width: 100%;
}

.tab-col button {
    flex: 1;
    /* Makes both tabs take equal space */
    padding: 10px;
    text-align: center;
    border: none;
    background: transparent;
    transition: background 0.3s ease-in-out;
    font-weight: bold;
    color: #171717;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
}

.tab-col button img {
    margin-right: 5px;
}

.tab-col button.active-tab {
    background: white;
    border-radius: 20px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

.icon-container {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
}

.back-button,
.delete-button {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
}

.top-container {
    max-width: 400px;
    margin: auto;
    background: #fff;
    padding: 20px;
    font-family: Arial, sans-serif;
}

.input-with-icon {
    position: relative;
    width: 100%;
}

.input-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    pointer-events: none;
}

/* Target CInput directly */

.input-with-icon>>>input,
/* Vue deep selector */

.input-with-icon input {
    padding-left: 40px !important;
    /* Override existing padding */
}
</style>
